import axiosInstance from '../../../../common/axios.service';
import type {ADD_BATTERY, UPDATE_BATTERY} from './batteries.type';
import type FILTERS from '../../../../common/filters.type';

const batteriesList = (values: FILTERS) => {
  return axiosInstance.get('battery/', {params: values}).then((response) => {
    return response;
  });
};

const addBattery = (values: ADD_BATTERY) => {
  return axiosInstance.post('battery', values).then((response) => {
    return response;
  });
};

const updateBattery = (values: {id: number; payload: UPDATE_BATTERY}) => {
  return axiosInstance.put(`battery/${values.id}`, values.payload).then((response) => {
    return response;
  });
};

const unregisteredBatteries = (rack_id: number) => {
  return axiosInstance.get('battery/unregistered', {params: {rack_id}}).then((response) => {
    return response;
  });
};

const batteriesServices = {
  batteriesList,
  addBattery,
  updateBattery,
  unregisteredBatteries,
};

export default batteriesServices;
